import App from './App.vue';
import { router } from './router';
import { initSentry } from './configs/sentry';
import { createApp } from 'vue';
import { AVPlugin } from 'vue-audio-visual';

const app = createApp(App);

void initSentry();

app.use(router);
app.use(AVPlugin);

app.mount('#app');
